import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render, unmountComponentAtNode } from "react-dom"

import { ModalContainer } from "web/components"
import SearchResultWrapper from "web/components/GlobalSearch/SearchResultWrapper"
import { AppProviders, LibraryProviders } from "web/Providers"

export default class GlobalSearchResultsController extends Controller {
  initialize() {
    global.React = React
  }

  connect() {
    render(
      <Suspense fallback={null}>
        <LibraryProviders>
          <AppProviders>
            <SearchResultWrapper />
            <ModalContainer />
          </AppProviders>
        </LibraryProviders>
      </Suspense>,
      this.element
    )
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }
}
